export const PARENT_PRODUCTS = {
	CONFLUENCE: 'confluence',
	JIRA: 'jira',
} as const;

export type PanelData = string;

export interface PanelDataMap {
	[key: string]: PanelData | undefined;
	embedUrl?: string;
}
